import type { ShareContentType } from '../share-criteria-types.ts';

/**
 * Resolves the per-content-type Post Office trigger id for the "criteria met"
 * nudge.
 *
 * - Primary (first instance):   `flag-to-share-criteria-met.${contentType}`
 * - Nth+ (second+ instance):    `flag-to-share-criteria-met-nth.${contentType}`
 *
 * `isNth` is derived by callers from local storage (see `useFlagToShare` and
 * `flagToShareTriggerState`), reflecting whether this content type has
 * already fired the trigger at least once before on this device. It
 * defaults to `false` so callers that don't yet track per-type history
 * still fire the primary trigger.
 */
export function getTriggerId(contentType: ShareContentType, isNth: boolean = false): string {
	const base = isNth ? 'flag-to-share-criteria-met-nth' : 'flag-to-share-criteria-met';
	return `${base}.${contentType}`;
}
